import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import api, { errMsg } from "@/lib/api";
import { useMeta } from "./useMeta";

export const NewShopDialog = ({ open, onClose }) => {
  const meta = useMeta();
  const nav = useNavigate();
  const [f, setF] = useState({ name: "", category: "Auto Repair", phone: "", address: "", city: "", state: "", website: "" });
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (!open) setBusy(false); }, [open]);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      const { data } = await api.post("/api/dir/shops", f);
      toast.success(data.status === "active" ? "Shop page created" : "Thanks! Your page goes live once our team approves it");
      onClose(); if (data.status === "active") nav(`/directory/shop/${data.slug}`);
    } catch (er) { toast.error(errMsg(er)); }
    setBusy(false);
  };
  const sel = "h-10 w-full border rounded-md px-2 bg-white text-sm";
  return (
    <Dialog open={open} onOpenChange={v => !v && onClose()}>
      <DialogContent className="sm:max-w-lg bg-white" data-testid="dir-new-shop-dialog">
        <DialogHeader><DialogTitle className="text-2xl font-extrabold" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>List your shop</DialogTitle>
          <DialogDescription>Already in the directory? Find your page and tap "Claim this page" instead.</DialogDescription></DialogHeader>
        <form onSubmit={submit} className="grid grid-cols-2 gap-3">
          <Input required className="col-span-2" placeholder="Shop name" value={f.name} onChange={set("name")} data-testid="dir-new-name" />
          <select value={f.category} onChange={set("category")} className={sel} data-testid="dir-new-category">{(meta?.categories || []).map(c => <option key={c}>{c}</option>)}</select>
          <Input placeholder="Phone" value={f.phone} onChange={set("phone")} data-testid="dir-new-phone" />
          <Input className="col-span-2" placeholder="Street address" value={f.address} onChange={set("address")} data-testid="dir-new-address" />
          <Input required placeholder="City" value={f.city} onChange={set("city")} data-testid="dir-new-city" />
          <select required value={f.state} onChange={set("state")} className={sel} data-testid="dir-new-state"><option value="">State</option>{(meta?.states || []).map(s => <option key={s.code} value={s.code}>{s.name}</option>)}</select>
          <Input className="col-span-2" placeholder="Website (optional)" value={f.website} onChange={set("website")} data-testid="dir-new-website" />
          <button disabled={busy} className="col-span-2 h-11 rounded-full bg-amber-500 hover:bg-amber-400 text-slate-900 font-bold flex items-center justify-center gap-2 disabled:opacity-50" data-testid="dir-new-submit">{busy && <Loader2 className="w-4 h-4 animate-spin" />}Create my page</button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
